import { FileText, Receipt, TrendingDown, TrendingUp } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { TransactionType } from '@/types/transaction';

interface TransactionTypeBadgeProps {
  type: TransactionType;
  className?: string;
}

export function TransactionTypeBadge({ type, className }: TransactionTypeBadgeProps) {
  const config = {
    invoice: {
      label: 'Invoice',
      icon: FileText,
      className: 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300',
    },
    credit_note: {
      label: 'Credit Note',
      icon: TrendingDown,
      className: 'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300',
    },
    receipt: {
      label: 'Receipt',
      icon: Receipt,
      className: 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300',
    },
    debit_adjustment: {
      label: 'Debit Adjustment',
      icon: TrendingUp,
      className: 'bg-orange-100 text-orange-700 dark:bg-orange-900 dark:text-orange-300',
    },
    credit_adjustment: {
      label: 'Credit Adjustment',
      icon: TrendingDown,
      className: 'bg-pink-100 text-pink-700 dark:bg-pink-900 dark:text-pink-300',
    },
  };

  const entry = config[type] ?? config.invoice;
  const { label, icon: Icon, className: typeClassName } = entry;

  return (
    <Badge className={cn('gap-1', typeClassName, className)}>
      <Icon className="h-3 w-3" />
      {label}
    </Badge>
  );
}
